import * as amplify from "../util/amplify.ts";
import * as FwDatas from "../FwDatas.ts";
import * as INR from "../INR.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as forms from "../util/forms.js";
import * as Locale from "../util/Locale.js";
import * as libLocation from "../lib/location.ts";
import * as Screen from "../lib/Screen.js";
import * as os from "../lib/os.js";
import {getMainEmailIdentifier} from "../features/email_verify.js";


import TPL_quota from "../settings/settings-quota.mustache";
import TPL_members from "../settings/edit_family_members.mustache";
import TPL_admin from "../settings/edit_family_administrator.mustache";
import TPL_download from "../settings/download.mustache";
import TPL_editfamily from "../settings/settings_edit_family.mustache";
import TPL_language from "../settings/language.mustache";
import TPL_password from "../settings/change_password.mustache";
import TPL_credit from "../settings/credits.mustache";
import { addParams } from "../lib/url.ts";
import $ from "../$.js";
import { getPreference } from "../DarkMode.ts";

Html.register({
  mailtosupport(){
    var 
      user = FwDatas.getUser(),
      state = FwDatas.getState(),
      family = FwDatas.getFamily(),
      subject = i18n.get('support.subject'),
      body = `
    

User ${user.accountId}
${state?.premium?.fWPremiumPopup ? 'Premium true':''}
User-Agent ${navigator.userAgent}
OS ${os.code}   
    `
    window.open(addParams('mailto:support@familyandco.com',{body,subject}))
    
  }
})

  var
    // id of the default tab, without leading '#'
    DEFAULT_TAB_ID = "settings_edit_members";
  
  /*
    Function: displayChangePasswordSection()
    Display the section to change the password
  */
  function displayChangePasswordSection(){

    ApiServer['custom.changepassword'] = ApiServer.accchangepassword.prepare(function(data){
      modal.alert("changepassword.messageSuccess",function(){
        libLocation.goTo(INR.URL.SETTINGS);
      });
    },function(err){
      if(err.code==="3"){
        forms.markInvalid($('form[data-fw-dyn-action="custom.changepassword"] input[name="password"]'),i18n.get("fw2.apierrors.3"))
      }else{
        throw err;
      }
    })

    
    Html.setHtml($('#settings_content'),TPL_password,{emailIdentifier:getMainEmailIdentifier()});
    
  }

  /*
    Function: displayPreferences(family)
    Display the section for user preferences

    Parameter:
      family - object, extended family data
  */
  function displayPreferences(family){
    Html.setHtml($('#settings_content'),TPL_language,Locale);
    var selector = $('#settings_content').find('select');
    selector.val(i18n.getSelectedLanguage())
    if(selector.val()!==i18n.getSelectedLanguage()){
      selector.val(i18n.getShortLanguage())
    }
    var 
      darkModePref = getPreference(),
      onclickseek = "darkmode"+(darkModePref===null?'':('|'+darkModePref))
    document.querySelector("#settings_content .selectable [data-fw-onclick='"+onclickseek+"']").classList.add('selected')
    
  }
  
  /*
    Function: editFamily(family)
    Display the form to edit the family name and blazon

    Parameter:
      family - object, extended family data
  */
  function editFamily(family){
    const settingsContent = $("#settings_content")
    Html.setHtml(settingsContent,TPL_editfamily,family);
    settingsContent.find('form').on('submit',async function(evt){
      evt.preventDefault()
      await ApiServer.accupdatefamily(this)
      amplify.publish('familyChange')
      libLocation.refresh()
    })

  }
  
  function displayDownload(family){
    function display(link){
      Html.setHtml($("#settings_content"),TPL_download,{deepLoginLink:link});
    }
    ApiServer.accgenerateDeepLoginLink('enter_home.php',display,display);
    
  }
  function displayNotif(family){
    import("../settings/notification.mustache").then(function(TPL){
      ApiServer.settingsget(function(settings){
        Html.setHtml($("#settings_content"),TPL,settings);
      });
      
    })
    
  }
  Html.register({
    cookiesettings(){
      document.getElementById('ot-sdk-btn-floating').getElementsByTagName('button').item(0).dispatchEvent(new Event('click'));
    },
    wipefamily(){
      modal.ask({
        title:'new_confirm_action.title',
        message:i18n.get('settings.circledeleteconfirmtext',FwDatas.getFamily().name),
        button:[{value:"ok",title:'actions.yesdelete',class:"negative"},{title:'actions.nocancel'}]
      },function(opt){
        if(opt==='ok'){
          var afterWipe = ApiServer.famlistfamily.prepare(function(families){
            FwDatas.setFamilies(families)
            if(families.length){
              ApiServer.famlogfamily(families[0].metaId);
              libLocation.goTo('/home.php')
            }else{
              libLocation.goTo('/fw2_signup.php')
            }
          })  
          ApiServer.adminwipefamily(afterWipe)
          
        } 
      });
      
      
    },
    premiumcancel:function(metaId){
      var credit = FwDatas.get(metaId);
      modal.ask({
        title:'settings.credits.canceltitle',
        message:i18n.get('settings.credits.cancelconfirmation',credit),
        lottie:"/images/lottie/crying_face.json",
        button:[
          {title:'settings.credits.cancelpremium',class:"negative",value:"true"},
          {title:'settings.credits.remainpremium',action:'modalclose',class:"secondary"}
        ]},function(answer){
          if(answer==='true'){
            ApiServer.creditsetautorenewall(metaId,"NONE",displayCredit)
          }
        })

      
    },
    premiumrenewlink:function(metaId){
      ApiServer.creditgetmanualrenewalllink(metaId,function(url){
        window.open(url);
      })
      
    }
    
  })
    
  ApiServer["custom.locsetperuserauthflag"] = function(form){
    var 
      flags = {},
      tempDuration = {},
      accountId = $(form).metaId(),
      value = $(form).find('select').val();
    
    flags[accountId] = value.split('|')[0];
    if(value.split('|')[1]){
      tempDuration[accountId] = value.split('|')[1];
    }
    ApiServer.locsetperuserauthflag({flags:flags,tempDuration:tempDuration})
  }
  
  
  /*
    Function: displayFamilyMembersList(family)
    Display the list of family members

    Parameter:
      family - object, extended family data
  */
  function displayFamilyMembersList(family){
    Html.setHtml($("#settings_content"),TPL_members,{family:family});
  }

  /*
    Function: displayAdministratorsList(family)
    Display the list of family members to select administrators

    All administrators are displayed as checked, including the family
    founder, but the family founder cannot be unchecked.

    Parameter:
      family - object, extended family data
  */
  function displayAdministratorsList(family){
    Html.setHtml($("#settings_content"),TPL_admin,family);
  }
  
  function displayCredit(){
    ApiServer.customcreditget(function(credits){
      Html.setHtml($("#settings_content"),TPL_credit,{credits:credits,creationDate:FwDatas.getUser().creationDate});
    })
  }
  /*
    Function: displayFamilyStorage(family)
    Display settings for storage quotas

    Parameter:
      family - object, extended family data
  */
  function displayFamilyStorage(family){
    
    class Quota{
      constructor(owner,color,used, total){
        this.owner = owner;
        this.color = color;
        this.used = used||0;
        this.total = total;
        this.percent = Math.min(100,Math.round(100*this.used/this.total));
        this.totalAsString = this.text(this.total)
        this.usedAsString = this.text(this.used)
        
      }
      text(size){
        var unit = 0, crawler = size;
        while(crawler>1000){
          unit++;
          crawler /= 1000;
        }
        if(crawler<10){
          crawler = Math.round(10*crawler)/10;
        }else{
          crawler = Math.round(crawler);
        }
        return crawler+i18n.get("sizeunit."+['B','KB','MB','GB','TB'][unit]);
      }
      
    };
    
    ApiServer.albumquota(function(mediaQuota){
      var membersByQuota = FwDatas.getFamily().members.map(member=>{
        return new Quota(member,null,mediaQuota.usedByOwner[member.accountId],mediaQuota.familyQuota)
      });
      membersByQuota.sort(function(a,b){
        return b.used - a.used;
      });
      var mainQuota = new Quota(FwDatas.getFamily(),mediaQuota.color,mediaQuota.familyUsed,mediaQuota.familyQuota);
      if(mediaQuota.familyQuota<25000000000 && mediaQuota.familyUsed/mediaQuota.familyQuota>0.8){
        mainQuota.proposePremium = true;
      }
      mainQuota.membersByQuota = membersByQuota;
      
      Html.setHtml($("#settings_content"),TPL_quota,mainQuota);
    });
    
  }

  /*
    Function: displaySettings(data)
    Display settings page

    Parameter:
      data - object, initial page data, produced during start sequence
  */
  function displaySettings(tabId){
    var
      family = FwDatas.getFamily(),
      mapping = {
        settings_edit_family:editFamily,
        settings_edit_members:displayFamilyMembersList,
        settings_edit_admins:displayAdministratorsList,
        settings_edit_quotas:displayFamilyStorage,
        settings_password:displayChangePasswordSection,
        settings_preferences:displayPreferences,
        settings_download:displayDownload,
        settings_notif:displayNotif,
        settings_credits:displayCredit
      };
    if(!Screen.isMobileView()){
      tabId = tabId|| DEFAULT_TAB_ID;
      $(".pane-left .selectable>*").removeClass('selected');
      $(".pane-left .selectable>*[data-fw-onclick='settings|"+tabId+"']").addClass('selected');
      (mapping[tabId]||editFamily)(family);
    }else if(tabId){
      $(".pane-main").addClass('open');
      (mapping[tabId]||editFamily)(family);
    }else{
      $(".pane-main").removeClass('open');
    }
  }
  
  
  INR.onPage(INR.URL.SETTINGS,function(){
    
    INR.subscribe ("familyMemberSelected", function(event){
      if(event.selected!=="all"){
        Html.trigger('modaluser', [event.selected]);  
      }
    });

    INR.subscribe("rightsUpdated",function(){
      displaySettings('settings_edit_admins')
    });
    INR.subscribe("handleParam",function(){
      displaySettings(libLocation.getURLParam('tab'));
    });
    amplify.publish("handleParam")

  });
  Html.register({
    settings:function(tabId){
      libLocation.goTo('?tab='+tabId,!Screen.isMobileView());
    },
    adminchangeright:function(){
      ApiServer.adminchange((this.val()==="true")?"Admin":"None",[this.metaId()]);
      ApiServer.accgetallfamily(function(extentedFamily) {
        FwDatas.setFamily(extentedFamily);
      });
    }
  })